export default "__VITE_ASSET__kOH27zs2__"